module.exports = function _complement(f) {
  return function() {
    return !f.apply(this, arguments);
  };
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda/src/internal/_complement.js
// module id = 167
// module chunks = vendor